import axios, { AxiosResponse } from 'axios';
import { API_ENDPOINTS, getEndPoint } from './utils/endpoints';

export const resetPassword = async (params: any): Promise<any> => {
    const url: string = getEndPoint(API_ENDPOINTS.RESET_PASSWORD.CREATE);

    try {
        const api_reponse: AxiosResponse = await axios.post(url, { ...params });
        if (api_reponse.data) {
            return api_reponse.data;
        }
        throw Error(api_reponse.data.errorMessage);
    } catch (e) {
        const typedErr = e as Error;
        throw typedErr;
    }
};
